module.exports = __webpack_public_path__ + "static/img/green-judge.9b041eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/green-judge.png
// module id = V7gl
// module chunks = 32